import { memo, ReactNode } from 'react';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import LoginSideLogo from './LoginSideLogo';
import LoginCard from './LoginCard';

interface ILoginWrapperProps {
  children: ReactNode;
}

function LoginWrapper({ children }: ILoginWrapperProps): JSX.Element {
  return (
    <Grid container component="main" sx={{ height: '100vh' }}>
      <Grid
        item
        xs={0}
        lg={7}
        sx={{ display: { xs: 'none', lg: 'flex' }, alignItems: 'center', justifyContent: 'center' }}
      >
        <LoginSideLogo />
      </Grid>
      <Grid
        item
        xs={12}
        lg={5}
        component={Paper}
        elevation={0}
        square
        alignItems="center"
        sx={{ display: 'flex', justifyContent: { xs: 'center', lg: 'flex-start' } }}
      >
        <LoginCard isShadow={false}>{children}</LoginCard>
      </Grid>
    </Grid>
  );
}

export default memo(LoginWrapper);
